import React, { useState } from 'react';
import CustomIcon from '@appsinti/ui-core/CustomIcon';

import useI18n from '@appsinti/i18n/useI18n';

import Video from './Video';

import { IconContainer } from '../../../styles';
import { Container, Header, Title, Body } from '../styles';

import IArea from '@appsinti/bigbrother-frontend/interfaces/IArea';
import { useCollapse } from 'react-collapsed';

const Card: React.FC<{ area: IArea, isCollapsedInit?: boolean }> = ({ area, isCollapsedInit = false }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(isCollapsedInit);
  const { translateObject } = useI18n();
  const { getCollapseProps } = useCollapse({
    isExpanded: !isCollapsed,
  });

  return (
    <Container key={area.id}>
      <Header>
        <Title>
          {`${translateObject(area.name)} (${area.cameras.length})`}
        </Title>
        <IconContainer className='--is-right --is-collapsable' isCollapsable={!isCollapsed} onClick={() => setIsCollapsed(!isCollapsed)}>
          <CustomIcon icon='chevron-down' />
        </IconContainer>
      </Header>
      <div {...getCollapseProps({})}>
        <Body>
          {area.cameras.map(({ id, locationName, previewImageURL, streamingURL, status }) => (
            <Video
              key={id}
              streamURL={streamingURL}
              title={translateObject(locationName)}
              id={id}
              preview={previewImageURL}
              status={status}
            />
          ))}
        </Body>
      </div>
    </Container>
  );
};
export default Card;
